import './index.scss';

import React, { useEffect, useRef } from 'react';
import { Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

import useActions from '../../hooks/useActions';
import LongPaginationHandler from '../LongPaginationHandler';

const UnApprovedTransactionTable = ({ match }) => {
  const tableDate = useRef('2022-11-17');
  const searchRef = useRef();
  const dateRef = useRef();

  const {
    unapprovedTransactions,
    loading,
    total,
    page,
    perPage,
    tranxView,
    searchResult,
    searchResultLoading,
    searchResultError,
    filterResult,
    filterResultLoading,
    filterResultError,
    filterResultPage,
    filterResultTotal,
    filterResultPerPage
  } = useSelector((state) => state.unapproved);

  const {
    getUnApprovedTransactions,
    setBackLink,
    setUnApprovedView,
    searchUnApprovedTransactions,
    filterUnapprovedTransactions
  } = useActions();

  const {
    user: { stationId }
  } = useSelector((state) => state.auth);

  const paginate = (pageNumber) => {
    getUnApprovedTransactions(stationId, pageNumber);
  };

  const paginateFilter = (pageNumber) => {
    getUnApprovedTransactions(dateRef.current.value, stationId, pageNumber);
  };

  const searchHandler = (event) => {
    if (event.code === 'Enter') {
      if (!searchRef.current.value) {
        toast.error('Please enter a valid transaction ID');
        return;
      }

      setUnApprovedView('searching');
      searchUnApprovedTransactions(searchRef.current.value);
      searchRef.current.value = '';
    }
  };

  const filterHandler = () => {
    setUnApprovedView('filtering');
    filterUnapprovedTransactions(dateRef.current.value, stationId, 1);
  };

  useEffect(() => {
    if (!unapprovedTransactions) {
      getUnApprovedTransactions(stationId, page);
    }
  }, [page, stationId, getUnApprovedTransactions, unapprovedTransactions]);

  useEffect(() => {
    document.body.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div>
      <div className="unapproved_transactions">
        <div className="row mb-5">
          <div className="col-sm-6 col-md-8">
            <div className="unapproved_transactions_table_search">
              <input
                type="text"
                className="form-control p-2 unapproved_transactions_table_search_input"
                placeholder="Search by Transaction ID"
                aria-label="search"
                aria-describedby="button-addon2"
                ref={searchRef}
                onKeyDown={searchHandler}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-4">
            <div className="unapproved_transactions_filter row gx-2">
              <div className="col-7">
                <input
                  type="date"
                  ref={dateRef}
                  name="filter_date"
                  placeholder="Choose Filter Date"
                  className="form-control unapproved_transactions_filter_input"
                />
              </div>
              <div className="col-5">
                <button onClick={filterHandler} className="btn" type="button">
                  Apply Filter
                </button>
              </div>
            </div>
          </div>
        </div>
        {(tranxView === 'searching' || tranxView === 'filtering') && (
          <div className="">
            <button
              onClick={() => setUnApprovedView('normal')}
              type="button"
              className="mb-3 btn unapproved_transactions_general_button">
              Back to All Transactions
            </button>
          </div>
        )}
        <div className="unapproved_transactions_table">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Transaction ID</th>
                <th scope="col">Customer Name</th>
                <th scope="col">Phone No.</th>
                <th scope="col">Customer Type</th>
                <th scope="col">Gas Quantity</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            {tranxView === 'normal' && (
              <tbody>
                {loading && (
                  <tr className="py-3">
                    <td colSpan={7}>
                      <div className="d-flex justify-content-center w-100">
                        <Spinner className="spinner" animation="border" variant="dark" />
                      </div>
                    </td>
                  </tr>
                )}
                {!loading &&
                  unapprovedTransactions &&
                  unapprovedTransactions.length > 0 &&
                  unapprovedTransactions.map((tx) => {
                    const date = new Date(tx.created_at).toDateString();
                    if (date !== tableDate.current) {
                      tableDate.current = date;
                      return (
                        <React.Fragment key={tx.transaction_id}>
                          <tr className="unapproved_transactions_table_date_text text-end">
                            <td className="p-0" colSpan="7">
                              {new Date(tableDate.current).toDateString()}
                            </td>
                          </tr>
                          <tr>
                            <td>{tx.transaction_id}</td>
                            <td>{`${tx.lastname} ${tx.firstname}`}</td>
                            <td>{tx.phone}</td>
                            <td>{tx.customer_type}</td>
                            <td>{tx.gas_quantity} Kg</td>
                            <td>
                              <Link
                                to={`${match.url}/${tx.id}`}
                                onClick={() => setBackLink('/unapproved')}
                                className="btn unapproved_transactions_table_button">
                                View
                              </Link>
                            </td>
                          </tr>
                        </React.Fragment>
                      );
                    }
                    return (
                      <tr key={tx.transaction_id}>
                        <td>{tx.transaction_id}</td>
                        <td>{`${tx.lastname} ${tx.firstname}`}</td>
                        <td>{tx.phone}</td>
                        <td>{tx.customer_type}</td>
                        <td>{tx.gas_quantity} Kg</td>
                        <td>
                          <Link
                            to={`${match.url}/${tx.id}`}
                            className="btn unapproved_transactions_table_button">
                            View
                          </Link>
                        </td>
                      </tr>
                    );
                  })}
                {!loading && unapprovedTransactions && unapprovedTransactions.length === 0 && (
                  <tr>
                    <td colSpan={6}>
                      <div className="d-flex justify-content-center w-100">
                        <p className="text-danger">No Unapproved Transactions</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            )}
            {tranxView === 'searching' && (
              <tbody>
                {searchResultError && (
                  <tr>
                    <td colSpan={6}>
                      <div className="d-flex justify-content-center w-100">
                        <p className="text-danger">{searchResultError}</p>
                      </div>
                    </td>
                  </tr>
                )}
                {searchResultLoading && (
                  <tr className="py-3">
                    <td colSpan={6}>
                      <div className="d-flex justify-content-center w-100">
                        <Spinner className="spinner" animation="border" variant="dark" />
                      </div>
                    </td>
                  </tr>
                )}
                {searchResult &&
                  searchResult.length > 0 &&
                  searchResult.map((tx) => (
                    <tr key={tx.transaction_id}>
                      <td>{tx.transaction_id}</td>
                      <td>
                        {tx.firstname} {tx.lastname}
                      </td>
                      <td>{tx.phone}</td>
                      <td>{tx.customer_type}</td>
                      <td>{tx.gas_quantity} Kg</td>
                      <td>
                        <Link
                          to={`${match.url}/${tx.id}`}
                          onClick={() => setBackLink('/unapproved')}
                          className="btn unapproved_transactions_table_button">
                          View
                        </Link>
                      </td>
                    </tr>
                  ))}
                {!searchResultLoading && searchResult && searchResult.length === 0 && (
                  <tr>
                    <td colSpan={6}>
                      <div className="d-flex justify-content-center w-100">
                        <p className="text-danger">No Search Result</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            )}
            {tranxView === 'filtering' && (
              <tbody>
                {filterResultError && (
                  <tr>
                    <td colSpan={6}>
                      <div className="d-flex justify-content-center w-100">
                        <p className="text-danger">{filterResultError}</p>
                      </div>
                    </td>
                  </tr>
                )}
                {filterResultLoading && (
                  <tr className="py-3">
                    <td colSpan={6}>
                      <div className="d-flex justify-content-center w-100">
                        <Spinner className="spinner" animation="border" variant="dark" />
                      </div>
                    </td>
                  </tr>
                )}
                {filterResult &&
                  filterResult.length > 0 &&
                  filterResult.map((tx) => (
                    <tr key={tx.transaction_id}>
                      <td>{tx.transaction_id}</td>
                      <td>
                        {tx.firstname} {tx.lastname}
                      </td>
                      <td>{tx.phone}</td>
                      <td>{tx.customer_type}</td>
                      <td>{tx.gas_quantity} Kg</td>
                      <td>
                        <Link
                          to={`${match.url}/${tx.id}`}
                          onClick={() => setBackLink('/unapproved')}
                          className="btn unapproved_transactions_table_button">
                          View
                        </Link>
                      </td>
                    </tr>
                  ))}
                {filterResult && filterResult.length === 0 && (
                  <tr>
                    <td colSpan={6} className="w-100 text-center">
                      No Data
                    </td>
                  </tr>
                )}
              </tbody>
            )}
          </table>
        </div>
        {tranxView === 'normal' && (
          <LongPaginationHandler
            elementsPerPage={perPage}
            totalElements={total}
            activePage={page}
            paginate={paginate}
          />
        )}
        {tranxView === 'filtering' && (
          <LongPaginationHandler
            elementsPerPage={filterResultPerPage}
            totalElements={filterResultTotal}
            activePage={filterResultPage}
            paginate={paginateFilter}
          />
        )}
      </div>
    </div>
  );
};

export default UnApprovedTransactionTable;
